<fui-password-control [disabled]="isReadonly" [label]="label" [placeholder]="placeholder" [attr.id]="elementId" [allowAutocomplete]="allowAutocomplete"
                      [(ngModel)]="value" [notation]="notation" [control]="formControl">
</fui-password-control>
